import { render, staticRenderFns } from "./PasswordRecoveryConfirm.vue?vue&type=template&id=0e432bd4&lang=pug&"
import script from "./PasswordRecoveryConfirm.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports